module.exports = __webpack_public_path__ + "static/media/github_sm.bfa4414fec84c6ad0808639dd1ae9dc8.svg";